import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChassisTimeTableModel } from 'src/app/models/ChassisTimeTable';
import { ChassisUpdateModel } from 'src/app/models/ChassisUpdateModel';
import { PlannedTripPayload, TripPayload } from 'src/app/models/PackingPlanningModel';
import { ChassisService } from 'src/app/services/chassis/chassis.service';

@Component({
  selector: 'app-chassis-integration-form',
  templateUrl: './chassis-integration-form.component.html',
  styleUrl: './chassis-integration-form.component.css'
})
export class ChassisIntegrationFormComponent {

  timeTableIsVisible: boolean = false;

  sharedChassisTrip!: ChassisTimeTableModel | null

  @Input() dockIdReceived: number | null = null;

  dockNumber: number = 0;

  constructor(private chassisService: ChassisService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const dockIdFromUrl = +params['id'];
      if (dockIdFromUrl) {
        const dockMap = new Map<number, number>([
          [31, 1],
          [32, 2],
          [33, 3],
          [34, 4],
          [35, 5],
        ]);

        const mapped = dockMap.get(dockIdFromUrl);
        this.dockNumber = mapped ?? 0;
      }
    });
  }

  handleTripSelection(data: any) {
    this.sharedChassisTrip = data
  }

  shareTripData() {

    if (!this.sharedChassisTrip) { return alert("Selecione uma viagem da time-table antes de salvar!") }
    
    const payload: ChassisUpdateModel = {
      dockId: this.dockIdReceived!,
      tripId: this.sharedChassisTrip!.id!
    }

    this.chassisService.updateChassisTripsTable(payload).subscribe({
      next: () => {
        alert("Viagem atualizada")
      },
      error: (error) => {
        console.error("Erro ao atualizar dados: ", error);
        alert("Erro ao atualizar viagem");
      },
    })
  }

  clearFields() {
    this.sharedChassisTrip = {
      id: null,
      trip: null,
      processDescription: null,
      arrivalTimeSLA: null,
      departureTimeSLA: null,
      extra: null
    }
  }

  togglePlanning() {
    this.timeTableIsVisible = !this.timeTableIsVisible
  }
}
